// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ph_a bik_qt bik_a bik_w","FaqAskQuestion__outdated":"ph_b bik_vr bik_xg"};